import React, {Component} from 'react';
import {Icon, Menu, Popup} from 'semantic-ui-react';
import "./FriMenu.css";
import FriLoader from "../FriLoader";
import Chooser from "../main/Chooser";

export default class FriMenu extends Component {
    constructor() {
        super();
        this.state = {
            activePlus: false
        }
    }

    render() {
        return (
            <Menu className={"menu"}>
                <Chooser/>
                <Menu.Item header>frivola</Menu.Item>
                <Popup trigger={<Menu.Item
                    onClick={() => window.location.href = window.location.href.indexOf("/p") === -1 ? "p" : "/s"} header
                    name={window.location.href.indexOf("/p") === -1 ? "c" : "ч"}>
                </Menu.Item>} content='Preklopi'/>
                <Popup trigger={<Menu.Item active={this.state.activePlus} onClick={this.openChar.bind(this)}>
                    <Icon name='plus'/>
                </Menu.Item>} content="Vstavi"/>
                <Popup trigger={<Menu.Item onClick={() => this.copyToClp(this.props.all.sestavljeno)}>
                    <Icon name='clipboard'/>
                </Menu.Item>} content='Kopiraj vsebino polja 2'/>
                <Popup trigger={<Menu.Item onClick={() => this.copyToClp(this.props.all.razstavljeno)}>
                    <Icon name='clipboard outline'/>
                </Menu.Item>} content='Kopiraj vsebino polja 3'/>
                <Popup trigger={<Menu.Item onClick={() => this.props.doAltX()}>
                    <Icon name='retweet'/>
                </Menu.Item>} content='Znak/Koda'/>
                <Popup trigger={<Menu.Item onClick={() => this.props.openSettings()}>
                    <Icon name='setting'/>
                </Menu.Item>} content='Nastavitve'/>
                <FriLoader loadingText={this.props.loadingText} loading={this.props.loading}/>
            </Menu>
        );
    }

    doAltX() {
        this.props.altx();
    }

    openChar() {
        this.setState({activePlus: !this.state.activePlus});
        this.props.openChar();
    }

    copyToClp(txt) {
        txt = document.createTextNode(txt);
        document.body.appendChild(txt);
        let d;
        if (document.body.createTextRange) {
            d = document.body.createTextRange();
            d.moveToElementText(txt);
            d.select();
            document.execCommand('copy');
        } else {
            d = document.createRange();
            d.selectNodeContents(txt);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(d);
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
        }
        txt.remove();
    }
}



// WEBPACK FOOTER //
// ./src/components/menu/FriMenu.js